module.exports = __webpack_public_path__ + "img/3-2.cc962258.png";